import { generateLinkingConfig } from './webRouting';
import type { RootStackParamList } from '../navigation/types';

/**
 * Production-ready linking configuration with flattened URLs
 *
 * Features:
 * - Clean URLs: /recipes instead of /main/home/recipes
 * - camelCase parameters: /recipes/recipeId instead of /recipes/recipe-id
 * - SEO-friendly structure with proper metadata
 * - Performance optimized with lazy loading
 * - Cross-platform compatibility (web, mobile, desktop)
 */
export const linking = generateLinkingConfig();
